<div *ngIf="orgName" class="card-sm shadow-sm rounded-4 border-0 mb-2 parent-org-card">
  <div class="card-body py-3 px-4">
    <h6 class="mb-0 text-primary parent-org-title">
      Parent Organization: {{ orgName }}
    </h6>
  </div>
</div>

<div class="sub-org-table-container">
  <div *ngIf="showSuccess" class="success-message-top">
    <span class="badge bg-success">Sub-organization updated successfully!</span>
  </div>
  <table class="table table-bordered table-striped">
    <thead>
      <tr>
        <th>Edit</th>
        <th>Name</th>
        <th>Display Name</th>
        <th>Active</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let subOrg of pagedSubOrganizations">
        <td>
          <button mat-icon-button (click)="onEditSubOrganization(subOrg)">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
        <td>{{ subOrg?.name || "-" }}</td>
        <td>{{ subOrg?.displayName || "-" }}</td>
        <td>
          <input type="checkbox" [checked]="subOrg?.active ?? true" disabled />
        </td>
      </tr>
    </tbody>
  </table>
  <div class="pagination-container">
    <button (click)="prevPage()" [disabled]="currentPage === 1">Prev</button>
    <ng-container *ngFor="let page of [].constructor(totalPages); let i = index">
      <button (click)="goToPage(i + 1)" [class.active-page]="currentPage === i + 1">
        {{ i + 1 }}
      </button>
    </ng-container>
    <button (click)="nextPage()" [disabled]="currentPage === totalPages">Next</button>
  </div>
</div>
